import { type RootState } from '@/store';

export const activePathSelector = (state: RootState) => state.sideMenu.activePath;
